import { jsx, jsxs } from "react/jsx-runtime";
import { formView } from "@wix/bi-logger-forms-platform-uou/v2";
import { useBi, FormStatusProvider, Form } from "@wix/form-fields";
import { useCallback, useEffect } from "react";
import { useForm } from "../../hooks/use-form.js";
import { reportErrorChanges } from "../../hooks/use-validation.js";
import { DATA_HOOKS } from "../../tpa/widget/data-hooks.js";
import { SubmitStatusMessage } from "../submit-status-message/submit-status-message.js";
import { StepTitleA11y } from "./step-title-a11y.js";
const FormRoot = ({
  form: unprocessedForm,
  // renaming form to prevent accidental use
  values: unprocessedValues,
  // renaming values to prevent accidental use
  stepId,
  onStepIdChange,
  onChange,
  onBlur,
  onFocus,
  errors,
  onValidate,
  onSubmit,
  onSubmitSuccess,
  onSubmitFailure,
  forwardedRef,
  readOnly,
  overrides,
  actions,
  inProgress,
  config,
  breakpoint,
  onStatusChange,
  validationMode,
  fields,
  enableAutofill
}) => {
  const bi = useBi();
  const _onValidate = useCallback(
    (newErrors) => {
      reportErrorChanges({
        bi,
        existingErrors: errors,
        newErrors,
        form: unprocessedForm
      });
      onValidate(newErrors);
    },
    [bi, errors, onValidate, unprocessedForm]
  );
  const {
    formWithOverrides,
    normalizedValues,
    onFieldChange,
    currentStep,
    fieldActions,
    handleFieldValidation,
    currentView,
    formViews
  } = useForm({
    form: unprocessedForm,
    values: unprocessedValues,
    stepId,
    onStepIdChange,
    onChange,
    onBlur,
    onFocus,
    errors,
    onValidate: _onValidate,
    onSubmit,
    onSubmitSuccess,
    onSubmitFailure,
    fieldMap: fields,
    config,
    overrides,
    actions,
    inProgress,
    breakpoint,
    validationMode,
    forwardedRef,
    enableAutofill
  });
  useEffect(() => {
    bi.report(formView({ mode: readOnly ? "preview" : "live_site" }));
  }, []);
  if (!formViews?.length || !currentView) {
    return null;
  }
  return /* @__PURE__ */ jsx(FormStatusProvider, { onStatusChange, children: /* @__PURE__ */ jsxs("div", { "data-hook": DATA_HOOKS.FORM_ROOT, children: [
    /* @__PURE__ */ jsx(
      Form,
      {
        formSchema: formWithOverrides,
        form: currentView,
        values: normalizedValues,
        onFieldChange,
        onBlur,
        onFocus,
        errors,
        dataHook: DATA_HOOKS.FORM_ROOT,
        validateFields: handleFieldValidation,
        fields,
        fieldActions
      }
    ),
    /* @__PURE__ */ jsx(
      StepTitleA11y,
      {
        total: formWithOverrides.steps?.length,
        index: currentStep
      }
    ),
    /* @__PURE__ */ jsx(SubmitStatusMessage, {})
  ] }) });
};
export {
  FormRoot
};
//# sourceMappingURL=form-root.js.map
